import { logDispatcher } from "src/app/core/decorators/state.decorators";

export namespace ImportsActions {
    @logDispatcher
  export class StartCourseCyL {
    static readonly type = '[Imports] StartCourseCyL';
    constructor(public user: string) {}
  }

  @logDispatcher
  export class StartCourseCyLSuccess {
    static readonly type = '[Imports] StartCourseCyLSuccess';
    constructor() {}
  }

  @logDispatcher
  export class Error {
    static readonly type = '[Imports] Error';
    constructor(public error: any) {}
  }

  @logDispatcher
  export class SetFormExercise {
    static readonly type = '[Imports] SetFormExercise';
    constructor(public exerciseId: number) {}
  }

  @logDispatcher
  export class SetImportsDefaultState {
    static readonly type = '[Imports] SetImportsDefaultState';
    constructor() {}
  }

  @logDispatcher
  export class SetDefaultState {
    static readonly type = '[Imports] SetDefaultState';
    constructor() {}
  }
}